import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import './AdminTours.css';

const AdminTours = () => {
  const [tours, setTours] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showDetails, setShowDetails] = useState(null);
  const [filtroEstatus, setFiltroEstatus] = useState('todos');

  useEffect(() => {
    cargarTours();
  }, []);

  const cargarTours = async () => {
    try {
      setLoading(true);
      // 1. Aquí saca los datos 100% reales de tu API
      const response = await api.get('/tours');
      setTours(response.data);
    } catch (error) {
      console.warn('Cargando datos de prueba porque la API falló:', error.message);
      // Fallback: Datos de prueba SOLO si el backend falla
      const mockTours = [
        { id: 1, nombre: 'Juan Pérez García', email: 'juan@example.com', telefono: '555-123-4567', fecha_reserva: '2026-05-15', personas: 4, hora: '10:00', mensaje: 'Tour completo con catación.', estatus: 'pendiente', incluye_catacion: true, incluye_recorrido: true, incluye_buffet: false },
        { id: 2, nombre: 'María López', email: 'maria@example.com', telefono: '555-234-5678', fecha_reserva: '2026-05-18', personas: 2, hora: '11:30', mensaje: 'Celebración de aniversario.', estatus: 'confirmado', incluye_catacion: true, incluye_recorrido: false, incluye_buffet: false },
      ];
      setTours(mockTours);
    } finally {
      setLoading(false);
    }
  };

  const cambiarEstatus = async (id, nuevoEstatus) => {
    // 2. SEGURIDAD: Validación antes de cancelar
    if (nuevoEstatus === 'cancelado') {
      const confirmar = window.confirm('⚠️ ¿ESTÁS SEGURO? Estás a punto de CANCELAR esta reserva. Esta acción no se puede deshacer.');
      if (!confirmar) {
        return; // Si el administrador dice "Cancelar", abortamos la función y no pasa nada.
      }
    }

    try {
      // Actualizamos visualmente primero para que se sienta instantáneo
      setTours(tours.map(tour => tour.id === id ? { ...tour, estatus: nuevoEstatus } : tour));
      
      // Enviamos el cambio a tu API
      await api.put(`/tours/${id}`, { estatus: nuevoEstatus });
    } catch (error) {
      console.error('Error al actualizar el estatus:', error);
      alert('Hubo un error de conexión al actualizar la base de datos.');
    }
  };

  const enviarConfirmacion = async (tour) => {
    if(window.confirm(`¿Enviar correo de confirmación a ${tour.email}?`)) {
      try {
        alert(`✅ Correo enviado a ${tour.email}`);
      } catch (error) {
        console.error('Error enviando correo:', error);
      }
    }
  };

  const verDetalles = (id) => {
    setShowDetails(showDetails === id ? null : id);
  };

  const calcularCosto = (tour) => {
    let costo = 0;
    if (tour.incluye_catacion) costo += 200 * tour.personas;
    if (tour.incluye_recorrido) costo += 150 * tour.personas;
    if (tour.incluye_buffet && tour.personas >= 10) costo += 200 * tour.personas;
    return costo;
  };

  const toursFiltrados = filtroEstatus === 'todos' 
    ? tours 
    : tours.filter(t => t.estatus === filtroEstatus);

  if (loading) {
    return (
        <div className="admin-loading-screen">
            <div className="coffee-spinner">☕</div>
            <p>Cargando reservaciones...</p>
        </div>
    );
  }

  return (
    <div className="admin-page-container">
      <div className="admin-header-flex">
        <div>
          <h1>🎫 Gestión de Tours</h1>
          <p>Administra las reservaciones, cataciones y recorridos en la finca</p>
        </div>
        <button className="btn-action primary" onClick={() => alert('Abrir modal de nuevo tour')}>
          + Nueva Reserva
        </button>
      </div>

      <div className="filtros-card">
        <div className="filtros-group">
          <button className={`filtro-btn ${filtroEstatus === 'todos' ? 'active' : ''}`} onClick={() => setFiltroEstatus('todos')}>Todos</button>
          <button className={`filtro-btn ${filtroEstatus === 'pendiente' ? 'active' : ''}`} onClick={() => setFiltroEstatus('pendiente')}>Pendientes</button>
          <button className={`filtro-btn ${filtroEstatus === 'confirmado' ? 'active' : ''}`} onClick={() => setFiltroEstatus('confirmado')}>Confirmados</button>
          <button className={`filtro-btn ${filtroEstatus === 'completado' ? 'active' : ''}`} onClick={() => setFiltroEstatus('completado')}>Completados</button>
          <button className={`filtro-btn ${filtroEstatus === 'cancelado' ? 'active' : ''}`} onClick={() => setFiltroEstatus('cancelado')}>Cancelados</button>
        </div>
      </div>

      <div className="table-wrapper">
        <table className="admin-table tours-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Cliente</th>
              <th>Contacto</th>
              <th>Fecha y Hora</th>
              <th>Paquete</th>
              <th>Costo Est.</th>
              <th>Estatus</th>
              <th className="text-right">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {toursFiltrados.length === 0 && (
              <tr><td colSpan="8" className="empty-state">No se encontraron tours con este estatus.</td></tr>
            )}
            
            {toursFiltrados.map(tour => (
              <React.Fragment key={tour.id}>
                <tr className={showDetails === tour.id ? 'row-expanded-active' : ''}>
                  <td className="fw-bold">#{tour.id}</td>
                  <td><strong>{tour.nombre}</strong><br/><small>{tour.personas} Personas</small></td>
                  <td>
                    <div className="contact-info">
                      <a href={`mailto:${tour.email}`} className="text-link">📧 {tour.email}</a><br/>
                      <a href={`tel:${tour.telefono}`} className="text-link">📞 {tour.telefono}</a>
                    </div>
                  </td>
                  <td>
                    <strong>{new Date(tour.fecha_reserva).toLocaleDateString('es-MX')}</strong><br/>
                    <small>⏰ {tour.hora} hrs</small>
                  </td>
                  <td>
                    <div className="tags-container">
                      {tour.incluye_catacion && <span className="tag-paquete catacion">Catación</span>}
                      {tour.incluye_recorrido && <span className="tag-paquete recorrido">Recorrido</span>}
                      {tour.incluye_buffet && tour.personas >= 10 && <span className="tag-paquete buffet">Buffet</span>}
                    </div>
                  </td>
                  <td className="fw-bold" style={{color: '#2E7D32'}}>${calcularCosto(tour)} MXN</td>
                  
                  {/* Selector con la validación de cancelación activa */}
                  <td>
                    <select 
                      value={tour.estatus}
                      onChange={(e) => cambiarEstatus(tour.id, e.target.value)}
                      className={`status-select-badge ${tour.estatus}`}
                    >
                      <option value="pendiente">Pendiente</option>
                      <option value="confirmado">Confirmado</option>
                      <option value="completado">Completado</option>
                      <option value="cancelado">Cancelado</option>
                    </select>
                  </td>
                  
                  <td>
                    <div className="acciones-flex">
                      <button className="btn-icon-action" onClick={() => verDetalles(tour.id)} title="Ver detalles y notas">
                        {showDetails === tour.id ? '🔽' : '👁️'}
                      </button>
                      <button className="btn-icon-action" onClick={() => window.open(`https://wa.me/52${tour.telefono.replace(/\D/g, '')}`, '_blank')} title="WhatsApp">
                        💬
                      </button>

                      {/* 3. Lógica de Botones Dinámicos de Flujo */}
                      {tour.estatus === 'pendiente' && (
                        <button className="btn-icon-action info" onClick={() => cambiarEstatus(tour.id, 'confirmado')} title="Confirmar Tour" style={{borderColor: '#1565C0', background: '#E3F2FD'}}>
                          👍
                        </button>
                      )}
                      
                      {tour.estatus === 'confirmado' && (
                        <button className="btn-icon-action success" onClick={() => cambiarEstatus(tour.id, 'completado')} title="Marcar como Completado">
                          ✅
                        </button>
                      )}
                    </div>
                  </td>
                </tr>

                {showDetails === tour.id && (
                  <tr className="row-expanded-details">
                    <td colSpan="8">
                      <div className="expanded-content">
                        <div className="expanded-box">
                          <h4>📝 Notas del Cliente</h4>
                          <p>{tour.mensaje || 'No hay notas adicionales para esta reserva.'}</p>
                        </div>
                        <div className="expanded-box">
                          <h4>⚙️ Opciones Rápidas</h4>
                          <div className="quick-buttons">
                            <button className="btn-outline" onClick={() => enviarConfirmacion(tour)}>Reenviar Correo</button>
                            <button className="btn-outline text-danger" onClick={() => cambiarEstatus(tour.id, 'cancelado')}>Cancelar Reserva</button>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminTours;